import BaseBehavior from '../../../framework/base/base';
import { removeComments } from '../../../shared/utilities/comments';

export default class OffCanvasTrigger extends BaseBehavior {
	constructor(element) {
		super(element);
		this.addEventListeners();
		this.processDCF();
	}

	processDCF() {
		const dcfTargetDOM = document.getElementById(this.element.dataset.target);
		if (dcfTargetDOM && this.element.dataset.scriptsTarget) {
			const htmlContent =
				dcfTargetDOM.nodeName === 'SCRIPT' ? dcfTargetDOM.innerHTML : dcfTargetDOM.outerHTML;
			const dcfTargetDOMString = removeComments(htmlContent).replace(
				/(<[^>]*\s)(id|for)=("|')/g,
				'$1$2=$3' + this.instanceId + '-'
			);
			const parser = new DOMParser();
			const dcfScript = parser
				.parseFromString(dcfTargetDOMString, 'text/html')
				.querySelector('script');

			if (dcfScript?.src) {
				this.prefetchDCF(dcfScript);
				this.triggerDCFForm(dcfScript);
			}
		}
	}

	prefetchDCF(dcfScript) {
		if (window.dcfPrefetched) return;
		// dcf assests prefetch hints were not added, so add now.
		const docFragment = document.createDocumentFragment();
		const scriptLink = document.createElement('link');
		// Add script link
		scriptLink.setAttribute('rel', 'prefetch');
		scriptLink.setAttribute('href', dcfScript.src);
		docFragment.appendChild(scriptLink);
		// Add css link
		const cssLink = document.createElement('link');
		cssLink.setAttribute('rel', 'prefetch');
		// make src link for css
		let navLink = document.createElement('a');
		navLink.href = dcfScript.src;
		const navLinkPath = navLink.pathname.substring(0, navLink.pathname.lastIndexOf('/'));
		/**
		DCF on their end uses url root until widget.js assest to load theme css.
		So, if we have widget.js src as `https://dcf-server/dcf-path/widget.js`, then css url should
		be in format `{url-origin-of-widegt.js}/{url-path-untill-widgetjs}/themes/{dataset-theme-value}/theme.min.css`.
		This will translate here to `https://dcf-server/dcf-path/themes/theme-name/theme.min.css.js`
		* */
		cssLink.setAttribute(
			'href',
			`${navLink.origin}${navLinkPath}/themes/${dcfScript.dataset.theme}/theme.min.css`
		);
		docFragment.appendChild(cssLink);
		document.head.appendChild(docFragment);
		// dont create prefetch hint 2nd time & onwards.
		window.dcfPrefetched = true;
		navLink = null;
	}

	processDCFFormTrigger() {
		if (!document.body.classList.contains('v2-off-canvas--open')) {
			this.element.click();
		}
	}

	triggerDCFForm(dcfScript) {
		const searchParams = new URLSearchParams(document.location.search);
		if (dcfScript.dataset.widgetId === searchParams.get('formId')) {
			this.processDCFFormTrigger();
			this.subscribe('/off-canvas/ready', this.processDCFFormTrigger.bind(this));
		}
	}

	addEventListeners() {
		this.addEventListener(this.element, 'click', e => {
			const offCanvasBtn = this.element.dataset.target
				? this.element
				: e.target.closest('a[data-behavior="off-canvas-trigger"]');
			if (!offCanvasBtn) {
				return;
			}
			e.preventDefault();
			const types = ['target', 'scriptsTarget', 'wide', 'float', 'breakpoints', 'parentComponent'];
			const evtData = types.reduce(
				(type, key) => Object.assign(type, { [key]: offCanvasBtn.dataset[key] }),
				{}
			);
			this.publish('/off-canvas/open', evtData);
		});
	}

	removeEventListeners() {
		this.removeEventListener(this.element, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}
